module.exports = __webpack_public_path__ + "img/plat2.00396364.png";